<template>
  <div>
    <article class="mother-solve clearfix">
      <div class="solve-top">
        <h3>我们能为母婴解决的难点</h3>
        <span></span>
      </div>
      <span class="solve-text">
        结合传统母婴痛点，对症下药
      </span>
      <div class="solve-content clearfix">
        <div class="content" v-for="list in productList" :key="list.id">
          <div class="content-top">
            <img :src="list.img" />
          </div>
          <div class="content-center">
            <span class="desc">{{ list.desc }}</span>
          </div>
          <div class="content-bottom">
            <span class="desc1">{{ list.desc1 }}</span>
          </div>
        </div>
      </div>
    </article>
    <article class="mother-system clearfix">
      <div class="system-top">
        <h3>母婴电商运营体系</h3>
        <span></span>
      </div>
      <span class="system-text">
        整合“跨境+母婴”全渠道解决方案，助力企业抢占行业先机
      </span>
      <div class="system-content">
        <img src="../../static/images/mother/yytx.png" />
      </div>
    </article>
    <article class="mother-value clearfix">
      <div class="value-top">
        <h3>核心价值</h3>
        <span></span>
      </div>
      <span class="value-text">
        专属导购一对一为您进行优质化服务
      </span>
      <div class="value-content">
        <div class="item" v-for="item in customList" :key="item.id">
          <div @mouseenter="mouseEnter(item.id)" @mouseleave="mouseLeave">
            <img v-if="number == item.id" :src="item.acitveImg" />
            <img v-else :src="item.img" />
          </div>
          <div class="desc">
            {{ item.desc }}
          </div>
          <div class="desc1">
            {{ item.desc1 }}
          </div>
        </div>
      </div>
    </article>
    <article class="mother-function clearfix">
      <div class="function-top">
        <h3>系统功能</h3>
        <span></span>
      </div>
      <span class="function-text">
        打造线上交易平台，通过多元化促销方式推广商品
      </span>
      <div class="function-content">
        <img class="content-img" src="../../static/images/mother/t.png" />
        <address class="content top-left">
          <img src="../../static/images/mother/01.png" />
          <div class="right">
            <h3>开拓线上渠道</h3>
            <h4>建设品牌商城，植入小程序，开拓线上销售渠道</h4>
          </div>
        </address>
        <address class="content top-right">
          <img src="../../static/images/mother/02.png" />
          <div class="right">
            <h3>自助下单</h3>
            <h4>
              开通微商城，实现客户自助下单，商家通过后台可对会员、订单数据进行统一管理方便快捷，提高工作效率
            </h4>
          </div>
        </address>
        <address class="content bottom-left">
          <img src="../../static/images/mother/03.png" />
          <div class="right">
            <h3>订单管理</h3>
            <h4>
              通过订单管理系统，下单、出库全程跟踪紧遵下单时间，及时送达,提高产品、会员订单的管理效率
            </h4>
          </div>
        </address>
        <address class="content bottom-right">
          <img src="../../static/images/mother/04.png" />
          <div class="right">
            <h3>营销活动</h3>
            <h4>
              通过裂变营销方式及各种营销活动，以客传客，提升口碑品牌，让粉丝互动更加简单
              提高客户的二次消费率及客户黏性
            </h4>
          </div>
        </address>
      </div>
    </article>
    <article class="mother-product clearfix">
      <div class="product-top">
        <h3>产品特性</h3>
        <span></span>
      </div>
      <span class="product-text">
        鲜明的产品特性，实现全渠道销售方式和互动方式
      </span>
      <div class="product-content">
        <div class="content-top clearfix">
          <div class="left">
            <img src="../../static/images/mother/qqd.png" />
          </div>
          <div class="right">
            <div class="right-top">
              <span class="right-nubmer">01</span>
              <span class="right-circle"></span>
              <span class="right-text">全渠道销售 数据统一管理</span>
            </div>
            <span class="right-content"
              >传统母婴行业销售模式单一，一匠科技深度定制母婴商城解决方案打造线上+线下，移动+PC全渠道多平台统一经营</span
            >
            <div class="right-bottom">
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">会员信息管理</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">多平台全渠统一</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">订单销售管理</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">智慧客服在线互动</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">商家多店铺管控</div>
              </address>
            </div>
          </div>
        </div>
        <div class="content-bottom clearfix">
          <div class="left">
            <div class="right-top">
              <span class="right-nubmer">02</span>
              <span class="right-circle"></span>
              <span class="right-text">多元推广 全渠道顾客互动</span>
            </div>
            <span class="right-content"
              >基于实体店的自然客流，母婴零售商实现实体转型，增加线上平台，以多元化的促销手段推广商品</span
            >
            <div class="right-bottom">
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">商品促销</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">商品拼团</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">商品砍价</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">订单返现</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">线下活动</div>
              </address>
              <address class="bottom-item">
                <div class="yuan"></div>
                <div class="text">经验分享</div>
              </address>
            </div>
          </div>
          <div class="right">
            <img src="../../static/images/mother/dy.png" />
          </div>
        </div>
      </div>
    </article>
    <!-- <address class="mother-footer clearfix">
      <h3>让营销从此变得多姿多彩，现在咨询更多优惠！</h3>
      <a>立即咨询</a>
    </address> -->
  </div>
</template>
<script>
export default {
  name: "mother",
  data() {
    return {
      number: -1,
      productList: [
        {
          id: 0,
          img: require("../../static/images/mother/gyl.png"),
          desc: "供应链管控难",
          desc1: "缺乏流量获取渠道，供应链效率低下，库存信息传递慢",
        },
        {
          id: 1,
          img: require("../../static/images/mother/xs.png"),
          desc: "销售渠道陈旧",
          desc1: "商品单一，运营成本高，需要解决发货、售后等一系列问题",
        },
        {
          id: 2,
          img: require("../../static/images/mother/hk.png"),
          desc: "获客成本高",
          desc1: "代理商利润稀薄，投资门槛高，渠道单一，获客成本高",
        },
        {
          id: 3,
          img: require("../../static/images/mother/yx.png"),
          desc: "营销方式落后",
          desc1: "销售范围窄，没有更多的收益来源",
        },
        {
          id: 4,
          img: require("../../static/images/mother/zjpt.png"),
          desc: "自建平台投入高",
          desc1: "飞进打造高品质的解决方案对用户需求量身定制",
        }
      ],
      customList: [
        {
          id: 0,
          img: require("../../static/images/mother/1wxz.png"),
          acitveImg: require("../../static/images/mother/1xz.png"),
          desc: "导购专属身份",
          desc1: "导购专属二维码,通过绑定客户 成为导购专属客户",
        },
        {
          id: 1,
          img: require("../../static/images/mother/2wxz.png"),
          acitveImg: require("../../static/images/mother/2xz.png"),
          desc: "导购商品",
          desc1: "设置滞销商品为分润商品 促进商品售卖",
        },
        {
          id: 2,
          img: require("../../static/images/mother/3wxz.png"),
          acitveImg: require("../../static/images/mother/3xz.png"),
          desc: "导购激励",
          desc1: "线上下单，专属导购获得分润 线下导购开单，导购获得分润",
        },
        {
          id: 3,
          img: require("../../static/images/mother/4wxz.png"),
          acitveImg: require("../../static/images/mother/4xz.png"),
          desc: "导购开单",
          desc1: "导购为客户进行开单 带来更多销量",
        },
        {
          id: 4,
          img: require("../../static/images/mother/5wxz.png"),
          acitveImg: require("../../static/images/mother/5xz.png"),
          desc: "即时服务",
          desc1: "导购专属客服，一对一专属服务 提升客户消费体验",
        },
        {
          id: 5,
          img: require("../../static/images/mother/6wxz.png"),
          acitveImg: require("../../static/images/mother/6xz.png"),
          desc: "业绩指标",
          desc1: "指定销售目标，分配给门店和导购，促进导购积极性",
        },
        {
          id: 6,
          img: require("../../static/images/mother/7wxz.png"),
          acitveImg: require("../../static/images/mother/7xz.png"),
          desc: "业绩跟踪",
          desc1: "分配销售指标实时查看销售业绩",
        },
      ],
    }
  },
  mounted() {
  },
  methods: {
    mouseEnter(index) {
      this.number = index;
    },
    mouseLeave() {
      this.number = -1;
    },
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    }
  }
}
</script>
<style lang="stylus" scoped>
.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

div {
  color: #333333;
}

.mother-solve {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .solve-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .solve-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .solve-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .solve-content {
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: 34px;

    .content {
      width: 256px;
      height: 320px;
      float: left;
      margin-left: 30px;
      margin-top: 24px;
      border: 1px solid #F3F3F3;
      box-sizing: border-box;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
      background: #F7F7F7;
      border-radius: 4px;

      .content-top {
        margin-top: 68px;
      }

      .content-center {
        font-size: 18px;
        margin-top: 27px;
        font-weight: bold;
      }

      .content-bottom {
        margin: 15px auto;
        padding: 19px 41px;
        font-size: 14px;
        line-height: 30px;
      }
    }

    .content:hover {
      transform: scale(1.05, 1.05);
    }

    .content:first-child {
      margin-left: 0;
    }
  }
}

.mother-system {
  width: 1443px;
  margin: 0 auto;
  text-align: center;

  .system-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .system-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .system-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .system-content {
    width: 1443px;
    height: 598px;
    margin-top: 57px;
  }
}

.mother-value {
  width: 1400px;
  margin: 80px auto;
  margin-top: 51px;
  text-align: center;

  .value-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .value-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .value-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .value-content {
    width: 1400px;
    height: 240px;
    margin-top: 60px;

    .item {
      width: 145px;
      text-align: center;
      float: left;
      margin-left: 64px;
    }

    .item:first-child {
      margin-left: 0;
    }

    .active {
      color: #FFC000;
    }

    .desc {
      padding-top: 26px;
      padding-bottom: 22px;
      font-size: 18px;
      font-weight: bold;
    }

    .desc1 {
      line-height: 28px;
      font-size: 14px;
    }
  }
}

.mother-function {
  width: 1400px;
  height: 675px;
  margin: 80px auto;
  text-align: center;

  .function-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .function-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .function-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .function-content {
    margin-top: 42px;
    position: relative;

    .content-img {
      position: absolute;
      left: 429px;
      top: 0;
      z-index: 0;
    }

    .content {
      position: absolute;
      z-index: 1;
      width: 532px;
      height: 160px;
      background: #FFFFFF;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
      border-radius: 4px;

      img {
        display: inline-block;
        float: left;
        margin-top: 31px;
        margin-left: 40px;
      }

      .right {
        text-align: left;
        margin-left: 5px;
        margin-top: 57px;

        h3 {
          font-size: 18px;
          font-weight: bold;
        }

        h4 {
          margin-left: 104px;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }

    .top-left {
      top: 18px;
      left: 20px;

      .right {
        h4 {
          margin-top: 15px;
        }
      }
    }

    .top-right {
      top: 18px;
      left: 848px;

      .right {
        h4 {
          padding-right: 49px;
          margin-top: 5px;
          line-height: 24px;
        }
      }
    }

    .bottom-left {
      left: 90px;
      top: 367px;

      .right {
        h4 {
          padding-right: 60px;
          margin-top: 5px;
          line-height: 24px;
        }
      }
    }

    .bottom-right {
      left: 788px;
      top: 367px;

      .right {
        h4 {
          padding-right: 32px;
          margin-top: 5px;
          line-height: 24px;
        }
      }
    }
  }
}

.mother-product {
  width: 1400px;
  margin: 0 auto;
  text-align: center;

  .product-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .product-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .product-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .product-content {
    width: 1400px;
    height: 800px;
    margin: 0 auto;
    margin-top: 70px;
    background-color: white;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);

    .content-top, .content-bottom {
      width: 100%;
    }

    .content-top .left {
      width: 50%;
      float: left;

      img {
        width: 100%;
      }
    }

    .content-top .right {
      width: 50%;
      float: right;
      text-align: left;
    }

    .right-top {
      display: flex;
      margin-top: 47px;
      margin-left: 40px;
      font-weight: bold;
      align-items: center;
    }

    .right-nubmer {
      font-size: 28px;
      color: #FFC526;
      z-index: 1;
    }

    .right-circle {
      width: 20px;
      height: 20px;
      display: block;
      margin-left: -13px;
      margin-top: -15px;
      content: '';
      border-radius: 50%;
      background: linear-gradient(to right top, transparent 30%, #FFC526);
    }

    .right-text {
      font-size: 20px;
      margin-left: 10px;
    }

    .right-content {
      display: inline-block;
      margin-top: 15px;
      margin-left: 92px;
      padding-right: 53px;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.5px;
    }

    .right-content:nth-child(2) {
      padding-right: 78px;
    }

    .right-bottom {
      margin-top: 49px;
      margin-left: 92px;

      .bottom-item {
        width: 160px;
        heigth: 18px;
        float: left;
        margin-right: 52px;
        margin-bottom: 40px;

        .yuan {
          width: 5px;
          height: 5px;
          background: #FFC000;
          border-radius: 50%;
          float: left;
          margin-top: 7.5px;
          margin-left: 1px;
          margin-right: 10px;
        }

        .text {
          font-size: 18px;
          font-weight: bold;
        }
      }

      .bottom-item:nth-child(3) {
        margin-right: 0px;
      }
    }

    .content-bottom .left {
      width: 50%;
      float: left;
      text-align: left;

      .right-bottom {
        .bottom-item {
          margin-right: 10px;
        }

        .bottom-item:nth-child(6) {
          margin-right: 0px;
        }
      }
    }

    .content-bottom .right {
      width: 50%;
      float: right;

      img {
        width: 100%;
      }
    }
  }
}

.mother-footer {
  width: 100%;
  height: 160px;
  margin-top: 161px;
  background: url('../../static/images/fiveG/bg(1).png');
  text-align: center;
  border-sizing: border-box;
  position: relative;
  z-index: 3;

  h3 {
    padding-top: 28px;
    font-size: 24px;
    line-height: 28px;
    color: #FFFFFF;
  }

  a {
    text-decoration: none;
    display: inline-block;
    width: 170px;
    height: 50px;
    margin: 24px auto;
    font-size: 18px;
    font-weight: bold;
    color: #FFFEFC;
    line-height: 50px;
    border: 1px solid #FFFEFC;
    border-radius: 4px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/solutionMother.vue